var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.celebrationPopup
        ? _c(
            "div",
            { staticClass: "bl-backdrop-overlay" },
            [
              _c("BlGif", {
                staticClass: "rounded-full h-72 w-72",
                attrs: { gif: "celebration" }
              })
            ],
            1
          )
        : _c(
            "BlBackdrop",
            {
              attrs: {
                label: "Accept (" + _vm.selectedRecommendation.length + ")",
                cancelLabel: "Skip recommendations",
                disabled: _vm.isDisabledAccept
              },
              on: {
                "backdrop-close": function($event) {
                  return _vm.$emit("close-modal")
                },
                "backdrop-action": _vm.onAccept
              }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-col gap-8 px-4 pt-4 pb-4 overflow-x-hidden overflow-y-auto lg:pt-8 lg:px-8",
                  style:
                    _vm.viewMode === "desktop"
                      ? { width: "75rem", maxHeight: "calc(100vh - 16rem)" }
                      : { maxHeight: "calc(100vh - 6rem)" }
                },
                [
                  _c("div", { staticClass: "flex flex-col gap-2" }, [
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "p-1 bg-orange-300 lg:p-2",
                            style: { borderRadius: "4px" }
                          },
                          [
                            _c("BlIcon", {
                              staticClass: "w-6 h-6",
                              attrs: { icon: "tooltip" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.viewMode === "desktop"
                          ? _c("BlTextTitle4", {
                              attrs: {
                                text:
                                  "Action recommendations: passing success metric"
                              }
                            })
                          : _c("BlTextSubtitle1", {
                              attrs: { text: "Passing success metric" }
                            })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.viewMode === "desktop"
                      ? _c(
                          "div",
                          {
                            staticClass: "flex flex-wrap items-center gap-x-1"
                          },
                          [
                            _c("BlTextBody2", {
                              attrs: {
                                text:
                                  "Below are the targets that have successfully reached their success metrics and may change their status to mastered. No worries if you choose to skip the"
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              attrs: {
                                text:
                                  "recommendation; you can still find this information on the"
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "font-bold",
                              attrs: { text: "Recommendations" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", { attrs: { text: "page." } })
                          ],
                          1
                        )
                      : _c("div", { staticClass: "space-y-4" }, [
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-2" },
                            [
                              _c("StatusChip", {
                                attrs: { status: "in_progress" }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-grey-300" }, [
                                _vm._v("→")
                              ]),
                              _vm._v(" "),
                              _c("StatusChip", {
                                attrs: { status: "mastered" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-wrap items-center gap-x-1"
                            },
                            [
                              _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    "Below are the targets that have successfully reached their success metrics and may change their status to mastered. No worries if you choose to skip the recommendation;"
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    "you can still find this information on the"
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "font-bold",
                                attrs: { text: "Recommendations" }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", { attrs: { text: "page." } })
                            ],
                            1
                          )
                        ])
                  ]),
                  _vm._v(" "),
                  _vm.viewMode === "desktop"
                    ? _c(
                        "div",
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flex text-grey",
                              attrs: { id: "metric-header" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-start flex-shrink-0 gap-2 px-3 py-2 rounded-l bg-grey-100 w-72"
                                },
                                [
                                  _c("BlInputCheck", {
                                    staticClass: "mt-1",
                                    attrs: {
                                      checked: _vm.masterChecked,
                                      indeterminate: _vm.masterIndeterminate
                                    },
                                    on: { changed: _vm.onChangeSelectedAll }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextSubtitle2", {
                                    attrs: { text: "Target" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex-shrink-0 w-48 px-3 py-2 bg-grey-100"
                                },
                                [
                                  _c("BlTextSubtitle2", {
                                    attrs: { text: "Success metric" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex-shrink-0 w-48 px-3 py-2 bg-grey-100"
                                },
                                [
                                  _c("BlTextSubtitle2", {
                                    attrs: { text: "Total successful sessions" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex-shrink-0 w-48 px-3 py-2 bg-grey-100"
                                },
                                [
                                  _c("BlTextSubtitle2", {
                                    attrs: {
                                      text: "Number of consecutive success"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex-shrink-0 w-64 px-3 py-2 rounded-r bg-grey-100"
                                },
                                [
                                  _c("BlTextSubtitle2", {
                                    attrs: { text: "Recommended action" }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.recommendations, function(recommendation) {
                            return _c(
                              "div",
                              { key: recommendation.id, staticClass: "flex" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-center flex-shrink-0 gap-2 px-3 py-4 border-b w-72 border-grey-200",
                                    attrs: { title: recommendation.target.name }
                                  },
                                  [
                                    _c("BlInputCheck", {
                                      attrs: {
                                        checked: _vm.selectedRecommendation.includes(
                                          recommendation.id
                                        )
                                      },
                                      on: {
                                        changed: function($event) {
                                          return _vm.onChangeSelected(
                                            recommendation.id
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextBody1", {
                                      staticClass: "truncate text-grey",
                                      attrs: {
                                        text: recommendation.target.name
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-center flex-shrink-0 w-48 px-3 py-4 border-b border-grey-200",
                                    attrs: {
                                      title: _vm.generateSuccessMetric(
                                        recommendation.target
                                      )
                                    }
                                  },
                                  [
                                    _c("BlTextBody1", {
                                      staticClass: "truncate text-grey-400",
                                      attrs: {
                                        text: _vm.generateSuccessMetric(
                                          recommendation.target
                                        )
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-center flex-shrink-0 w-48 px-3 py-4 border-b border-grey-200"
                                  },
                                  [
                                    _c("BlTextBody1", {
                                      staticClass: "truncate text-grey-400",
                                      attrs: {
                                        text: recommendation.target
                                          .total_success
                                          ? recommendation.target
                                              .total_success + " session(s)"
                                          : "-"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-center flex-shrink-0 w-48 px-3 py-4 border-b border-grey-200"
                                  },
                                  [
                                    _c("BlTextBody1", {
                                      staticClass: "truncate text-grey-400",
                                      attrs: {
                                        text: recommendation.target
                                          .consecutive_success
                                          ? recommendation.target
                                              .consecutive_success + " time(s)"
                                          : "-"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-center justify-between flex-shrink-0 w-64 gap-2 px-3 py-4 border-b border-grey-200"
                                  },
                                  [
                                    _c("StatusChip", {
                                      attrs: {
                                        status: recommendation.target.status
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "text-grey-300" },
                                      [_vm._v("→")]
                                    ),
                                    _vm._v(" "),
                                    _c("StatusChip", {
                                      attrs: {
                                        status:
                                          recommendation.recommended_action
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    : _c(
                        "div",
                        { attrs: { id: "mobile-popup" } },
                        _vm._l(_vm.recommendations, function(recommendation) {
                          return _c(
                            "div",
                            {
                              key: recommendation.id,
                              staticClass:
                                "flex flex-col py-5 border-b border-grey-200"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center justify-between gap-2"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex items-center gap-2 truncate"
                                    },
                                    [
                                      _c("BlInputCheck", {
                                        attrs: {
                                          checked: _vm.selectedRecommendation.includes(
                                            recommendation.id
                                          )
                                        },
                                        on: {
                                          changed: function($event) {
                                            return _vm.onChangeSelected(
                                              recommendation.id
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        staticClass: "truncate text-grey",
                                        attrs: {
                                          text: recommendation.target.name
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c("BlIcon", {
                                        staticClass:
                                          "flex-shrink-0 w-6 h-6 transition-all duration-300",
                                        style: _vm.detailsOpened.includes(
                                          recommendation.id
                                        )
                                          ? "rotate: 180deg"
                                          : "",
                                        attrs: {
                                          icon: "chevron-down",
                                          clickable: ""
                                        },
                                        on: {
                                          clicked: function($event) {
                                            return _vm.onOpenDetails(
                                              recommendation.id
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.detailsOpened.includes(recommendation.id)
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "grid grid-cols-2 px-6 py-2 gap-x-4 gap-y-2"
                                    },
                                    [
                                      _c("BlTextBody2", {
                                        staticClass: "truncate",
                                        attrs: { text: "Success metric" }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        staticClass: "truncate",
                                        attrs: {
                                          text: _vm.generateSuccessMetric(
                                            recommendation.target
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        staticClass: "truncate",
                                        attrs: {
                                          text: "Total successful sessions"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        staticClass: "truncate",
                                        attrs: {
                                          text: recommendation.target
                                            .total_success
                                            ? recommendation.target
                                                .total_success + " session(s)"
                                            : "-"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        staticClass: "truncate",
                                        attrs: {
                                          text: "Number of consecutive success"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        staticClass: "truncate",
                                        attrs: {
                                          text: recommendation.target
                                            .consecutive_success
                                            ? recommendation.target
                                                .consecutive_success +
                                              " time(s)"
                                            : "-"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        }),
                        0
                      )
                ]
              )
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74e3598f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74e3598f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sessions/modal/RecommendationPopup.vue
// module id = null
// module chunks = 